import React, { FC } from 'react';
import { DraftStatus } from 'api/Responses/SetResponses';
import { useLanguage } from 'context/AppContext';
import * as Styles from './BreadCrumbs.styles';
import Crumb from './Molecules/Crumb';

interface BreadCrumbProps {
  status: DraftStatus;
}

const BreadCrumbs: FC<BreadCrumbProps> = ({ status }) => {
  const [language] = useLanguage();

  return (
    <Styles.Container id="set-status-breadcrumb">
      <Crumb
        numLabel="1"
        textLabel={language.BreadCrumbs.draft}
        currentStatus={status}
        componentStatus={DraftStatus.DRAFT}
      />
      <Crumb
        numLabel="2"
        textLabel={language.BreadCrumbs.review}
        currentStatus={status}
        componentStatus={DraftStatus.REVIEW}
      />
      <Crumb
        numLabel="3"
        textLabel={language.BreadCrumbs.approve}
        currentStatus={status}
        componentStatus={DraftStatus.PENDING}
      />
      <Crumb
        numLabel="4"
        textLabel={language.BreadCrumbs.merged}
        currentStatus={status}
        componentStatus={DraftStatus.MERGED}
        renderLine={false}
      />
    </Styles.Container>
  );
};

export default BreadCrumbs;
